export { GoToTop as default } from './GoToTop';
